<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6Sa0Lu/tc-custom/9781426869167.jpg?1726519129388" alt="This image is the cover for the book Boots and Bullets, Whitehorse, Montana: Winchester Ranch Reloaded"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Boots and Bullets, Whitehorse, Montana: Winchester Ranch Reloaded
      </h1>
      <p class="bookDescription body article font2">
        <b>Convinced a murder is about to happen, a cowboy detective protects the pretty target in this romantic suspense from a <i>New York Times</i>–bestselling author.</b><br/><br/>Cyrus Winchester’s last attempt at helping a damsel in distress led to a coma and a stay in the Whitehorse hospital. But the Montana private investigator can’t seem to shake his protective instincts, especially when it comes to local shop owner Kate Landon. While unconscious, he had dreamed of her brutal murder—or was it a dream?<br/><br/>With her girl-next-door good looks and adventurous spirit, Kate doesn’t see herself as a victim—but Cyrus is sure that she’s in danger. And this cowboy at heart isn’t about to take a risk with her life. All he knows is that his investigation is bringing old secrets to life, secrets that point to Kate being a target of a merciless killer. Driven to keep her safe, he’d give his all to protect the woman he loves—but will it be enough?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        B. J. Daniels
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author B.J. Daniels lives in Montana with her husband, Parker, and two springer spaniels. When not writing, she quilts, boats and always has a book or two to read. Contact her at <a href="http://www.bjdaniels.com/">www.bjdaniels.com</a>, on Facebook at B.J. Daniels or through her reader group the B.J. Daniels' Big Sky Darlings, and on twitter at bjdanielsauthor.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?369bdbdd